import angular from 'angular';
import modulesProvider from './modules.provider';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.core.providers', [])
  .provider('modules', modulesProvider)
  .name;
